import React, { useState, useEffect } from "react";
import { ContentCard } from "@narmi/design_system";
import Account from "byzantine/src/Account";
import VerifyAccount from "../../settings/linked_accounts/VerifyAccount";

interface ExternalAccountTilesProps {
  externalAccounts: Account[];
  uatMicrodepAmntOne?: string;
  uatMicrodepAmntTwo?: string;
}

const ExternalAccountTiles: React.FC<ExternalAccountTilesProps> = ({
  externalAccounts,
  uatMicrodepAmntOne,
  uatMicrodepAmntTwo
}) => {
  // Filter to only unverified accounts for initial state
  const initialUnverifiedAccounts = externalAccounts.filter(
    (account) => !account.verified
  );

  const [
    currentUnverifiedExternalAccounts,
    setCurrentUnverifiedExternalAccounts
  ] = useState<Account[]>(initialUnverifiedAccounts);

  useEffect(() => {
    const unverifiedAccounts = externalAccounts.filter(
      (account) => !account.verified
    );
    setCurrentUnverifiedExternalAccounts(unverifiedAccounts);
  }, [externalAccounts]);

  const handleAccountVerified = (verifiedAccount: API.ExternalAccount) => {
    setCurrentUnverifiedExternalAccounts((prevAccounts) =>
      prevAccounts.filter((account) => account.id !== verifiedAccount.id)
    );
  };

  if (currentUnverifiedExternalAccounts.length === 0) {
    return null;
  }

  return (
    <>
      {currentUnverifiedExternalAccounts.map((account) => (
        <div key={account.id}>
          <ContentCard kind="elevated">
            <VerifyAccount
              account={account}
              callback={handleAccountVerified}
              uatMicrodepAmntOne={uatMicrodepAmntOne}
              uatMicrodepAmntTwo={uatMicrodepAmntTwo}
            />
          </ContentCard>
        </div>
      ))}
    </>
  );
};

export default ExternalAccountTiles;
